import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

// Services
import { BillingConceptInsertService } from '../../service/billing-concept-insert/billing-concept-insert.service';

@Component({
	selector: 'app-billing-concept-insert',
	templateUrl: './billing-concept-insert.component.html',
	providers: [
		BillingConceptInsertService,
		HttpModule
	]
})
export class BillingConceptInsertComponent implements OnInit {
	billingconcept: FormGroup;
	Nome: string = "";
	statusBillingConcept: boolean;
	private token;
	public permissoes: any[] = [];

	constructor(fb: FormBuilder, private billingconceptInsertService: BillingConceptInsertService, private flashMessagesService: FlashMessagesService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.billingconcept = fb.group({
			'Nome': [null, Validators.compose([Validators.required, Validators.maxLength(2)])],
			'Descricao': '',
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
	}

	addBillingConcept(value: any) {
		this.billingconceptInsertService.addBillingConcept(this.token, value).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show('Conceito de Cobrança cadastrado com sucesso', { cssClass: 'alert-success', timeout: 6000 });
				this.router.navigateByUrl('/conceito');
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			
		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/conceito');
	}
}



// WEBPACK FOOTER //
// ./src/app/billing-concept/component/billing-concept-insert/billing-concept-insert.component.ts